import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import useSelectedWarehouse from './hooks/useSelectedWarehouse'
import { useReduxDispatch, useReduxSelector } from 'store'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import Attribute from 'components/Attribute'
import { displayPrice } from 'utils/string'
import htbox1 from 'assets/img/htbox1.png'
import type { Size } from './Header'
import React from 'react'
import { v7 } from 'uuid'

export interface WarehouseGroup {
  name: string
  count: number
  free_now_to_rent_count: number
  isAvailableForRentNow: boolean
  warehouseTypeName: string
  warehousesInfo: Record<string, WarehouseGroupWarehousesInfo>
  realWarehouseIds: string[]
  data: WarehouseGroupData
  attrs: WarehouseGroupAttr[]
  for_rent: Record<string, string | null>
  for_reservation: any[]
  constructionDate: any
  badge: any
  details: WarehouseGroupDetail[]
  isAvailableForReservation: boolean
  order: number
}

interface WarehouseGroupWarehousesInfo {
  name: string
  number: string
}

interface WarehouseGroupData {
  area: number
  capacity: number
  categoryId: string
  defaultAttributes: string[]
  doorHeight: string
  doorWidth: string
  hasOnlineAccess: boolean
  height: string
  internalHeight: string
  internalLength: string
  internalWidth: string
  isFoldable: boolean
  length: string
  monthlyGrossPrice: string
  pricelistId: string
  rentalMinDays: number
  sqmPrice: string
  warehouseTypeId: string
  weight: string
  width: string
  dailyGrossPrice: string
  object: string
}

interface WarehouseGroupAttr {
  id: string
  key: string
  name: string
  icon?: string
  description?: string
  isImportant: boolean
  price: any
  title?: string
}

interface WarehouseGroupDetail {
  name?: string
  key: string
  list: WarehouseGroupList[]
}

interface WarehouseGroupList {
  id: string
  key: string
  name: string
  icon?: string
  description?: string
  isImportant: boolean
  price?: string
  title?: string
}

const Summary: React.FC = () => {
  const place = useReduxSelector(selectPlaceData)
  const warehouse = useSelectedWarehouse()
  const warehouseTypeData: Size | undefined = warehouse && place
    ? place.sizes.find((size: Size) => size.warehouseTypeId === warehouse.warehouseData?.attributes?.warehouseTypeId)
    : undefined
  const data: WarehouseGroup | undefined = warehouse && place
    ? place.warehouses[warehouse.warehouseData?.attributes?.warehouseTypeId || '']?.[warehouse.warehouseData?.hash || '']
    : undefined

  const { push } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('placeMap')

  const isDisabledForRent = !warehouse || !data || !warehouse.warehouseData?.status?.isAvailableForRent

  return (
    <div>
      <div className='placeMap__summary'>
        <div className='placeMap__summary__title'>
          <div>{t('selected')}</div>
          <div className='--secFont'>{data?.warehouseTypeName} #{warehouse?.name}</div>
        </div>
        <img
          className='placeMap__summary__image'
          alt='warehouse'
          src={warehouseTypeData?.renders?.default || htbox1}
        />
        <div className='placeMap__summary__content'>
          <div>{t('externalDimensions')}</div>
          <div>{warehouse?.warehouseData?.size?.width}m x {warehouse?.warehouseData?.size?.height}m x {warehouse?.warehouseData?.size?.length}m ({t('widthXHeightXLength')})</div>
        </div>
        {data?.attrs && data.attrs.length > 0 && <div className='placeMap__summary__content'>
          <div>{t('attributes')}</div>
          <div className='placeMap__summary__attributes'>
            {data.attrs.map(({ key, name }) => <Attribute
              key={key}
              iconKey={`${key}-bold`}
              name={name}
            />)}
          </div>
        </div>}
        <div className='placeMap__summary__content'>
          <div>{t('price')}</div>
          <div className='placeMap__summary__price'>
            <b>{displayPrice(warehouse?.warehouseData?.attributes?.monthlyGrossPrice || 0)}</b>
            <span> / {t('month')}</span>
          </div>
        </div>
      </div>
      <div className='placeMap__summary__buttons'>
        <BackBtn />
        <ArrowBtn
          text={t('rent')}
          disabled={isDisabledForRent}
          action={() => {
            if (isDisabledForRent) return
            const identifier = v7()
            const { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude } = place

            dispatch(addItemToBasket({
              identifier,
              id: warehouse.typeId,
              type: BASKET_TYPES.rent,
              object: data?.data?.object,
              hash: warehouse.warehouseData?.hash,
              address: { street, estateNumber, localNumber, city, province, gpslatitude, gpslongitude },
              hasOnlineAccess: data.data.hasOnlineAccess,
              size: warehouse.warehouseData?.size,
              name: data.warehouseTypeName,
              placeId: place.id,
            }))
            push(`/order/${identifier}`)
            dispatch(extendFormToMap(false))
          }} />
      </div>
    </div>
  )
}

export default Summary